const updateVisibleToReducer = (state, action) => ({
  ...state,
  files: action.payload.files
});

export default updateVisibleToReducer;
